import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { IonList, IonItem, IonLabel } from '@ionic/react';
import { formatCurrency } from 'utils/currency';
import { useSelector } from 'react-redux';
import { AuthSelectors } from 'redux/AuthRedux';
import { generateUuid } from 'utils/uuid';

function ReceiptDetail({ receipt }) {
  const user = useSelector(AuthSelectors.selectUser);
  const [check, setCheck] = useState();

  useEffect(() => {
    const foundCheck = receipt.checks.find((c) => c.userId === user._id);
    if (foundCheck) setCheck(foundCheck);
  }, [receipt, user]);

  if (!receipt || !check || !user) {
    return <h3>Receipt not found</h3>;
  }

  return (
    <IonList>
      <IonItem lines="none">
        <div>
          <h3>{receipt.venueName}</h3>
        </div>
      </IonItem>
      <IonItem lines="none" className="small">
        <IonLabel>{moment(receipt.updatedAt).format('MM/DD/YYYY')}</IonLabel>
      </IonItem>
      <IonItem lines="none" className="small mb-2x">
        <IonLabel>{moment(receipt.updatedAt).format('hh:mm A')}</IonLabel>
      </IonItem>
      {receipt.server && (
        <IonItem lines="none" className="small">
          <IonLabel>
            Server: {receipt.server.first_name} {receipt.server.last_name}
          </IonLabel>
        </IonItem>
      )}
      {receipt.table && (
        <IonItem lines="none" className="small">
          <IonLabel>Table: {receipt.table.name}</IonLabel>
        </IonItem>
      )}
      <IonItem lines="none" className="small">
        <IonLabel>Check: {check.extId || check._id}</IonLabel>
      </IonItem>
      <div className="divider mt-2x mb-2x" />
      {check.items.map((item) => (
        <IonItem key={generateUuid()} lines="none" className="small">
          <IonLabel>
            {item.quantity}&nbsp;&nbsp;
            {item.name}
          </IonLabel>
          <IonLabel slot="end" color="dark" className="menuitem-price">
            {formatCurrency(item.preDiscountPrice)}
          </IonLabel>
        </IonItem>
      ))}
      <div className="divider mt-2x" />
      <IonItem lines="none">
        <IonLabel>
          Card Number: XXXX-XXXX-XXXX-
          {receipt.checks[0] && receipt.checks[0].payments[0]
            ? receipt.checks[0].payments[0].last4
            : 'XXXX'}
        </IonLabel>
      </IonItem>
      <IonItem lines="none">
        <div>
          <h3>Subtotal:</h3>
        </div>
        <IonLabel slot="end" className="menuitem-price">
          <h3>
            {formatCurrency(
              receipt.totals.subTotal + (receipt.totals.discounts || 0)
            )}
          </h3>
        </IonLabel>
      </IonItem>
      <IonItem lines="none">
        <div>
          <h3>My Portion:</h3>
        </div>
        <IonLabel slot="end" className="menuitem-price">
          <h3>
            {formatCurrency(
              receipt.totals.subTotal + (receipt.totals.discounts || 0)
            )}
          </h3>
        </IonLabel>
      </IonItem>
      <IonItem lines="none" className="small">
        <IonLabel slot="start">Tax:</IonLabel>
        <IonLabel slot="end" className="menuitem-price">
          {formatCurrency(receipt.totals.tax)}
        </IonLabel>
      </IonItem>
      {!!receipt.totals.discounts && (
        <IonItem lines="none" className="small">
          <IonLabel slot="start">Discounts:</IonLabel>
          <IonLabel slot="end" className="menuitem-price">
            -{formatCurrency(receipt.totals.discounts)}
          </IonLabel>
        </IonItem>
      )}
      {!!receipt.totals.otherCharges && (
        <IonItem lines="none" className="small">
          <IonLabel slot="start">Additional Charge:</IonLabel>
          <IonLabel slot="end" className="menuitem-price">
            {formatCurrency(receipt.totals.otherCharges)}
          </IonLabel>
        </IonItem>
      )}
      {!!receipt.totals.serviceCharges && (
        <IonItem lines="none" className="small">
          <IonLabel slot="start">Service Fee:</IonLabel>
          <IonLabel slot="end" className="menuitem-price">
            {formatCurrency(receipt.totals.serviceCharges)}
          </IonLabel>
        </IonItem>
      )}
      {!!receipt.totals.gratuity && (
        <IonItem lines="none" className="small">
          <IonLabel slot="start">Automatic Gratuity:</IonLabel>
          <IonLabel slot="end" className="menuitem-price">
            {formatCurrency(receipt.totals.gratuity)}
          </IonLabel>
        </IonItem>
      )}
      <IonItem lines="none" className="small">
        <IonLabel slot="start">Tips:</IonLabel>
        <IonLabel slot="end" className="menuitem-price">
          {formatCurrency(receipt.totals.tips)}
        </IonLabel>
      </IonItem>
      <IonItem lines="none">
        <IonLabel slot="start">Total Paid:</IonLabel>
        <IonLabel slot="end" className="menuitem-price">
          {formatCurrency(receipt.totals.paid + receipt.totals.tips)}
        </IonLabel>
      </IonItem>
    </IonList>
  );
}

ReceiptDetail.propTypes = {
  receipt: PropTypes.object,
};

export default ReceiptDetail;
